(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class YGNewsletter extends HTMLElement {
    constructor() {
      super();
      this.initialized = false;
    }

    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      this.forms = Array.from(this.querySelectorAll('form'));

      this.forms.forEach((form) => {
        const agreementCheckbox = form.querySelector('[data-newsletter-agreement]');
        const submitButton = form.querySelector('[data-newsletter-submit]');

        if (!agreementCheckbox || !submitButton) return;

        const syncSubmitState = () => {
          submitButton.disabled = !agreementCheckbox.checked;
        };

        agreementCheckbox.addEventListener('change', syncSubmitState);
        syncSubmitState();
      });
    }
  }

  if (!window.customElements.get('yg-newsletter')) {
    window.customElements.define('yg-newsletter', YGNewsletter);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-featured-collection"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    class YGFeaturedProductList extends HTMLElement {
      constructor() {
        super();
        this.blockId = this.getAttribute('data-block-id');
      }

      connectedCallback() {
        this.initSwiper();
      }

      initSwiper() {
        const swiper = new Swiper(this, {
          breakpoints: {
            1150: {
              slidesPerView: 4,
              spaceBetween: 20,
            },
            750: {
              slidesPerView: 3,
              spaceBetween: 16,
            },
          },
          navigation: {
            nextEl: `.${this.blockId}-swiper-button-next`,
            prevEl: `.${this.blockId}-swiper-button-prev`,
            disabledClass: 'swiper-button-disabled',
          },
        });
      }
    }
    customElements.define('yg-featured-product-list', YGFeaturedProductList);

    class YGFeaturedBanner extends HTMLElement {
      constructor() {
        super();

        this.playVideoButton = this.querySelector('.yg-featured-banner-play-button');
        this.playVideoOnClick = this.playVideoOnClick.bind(this);
      }

      get videoTemplate() {
        if (window.innerWidth > 700) {
          return this.querySelector('template.pc');
        } else {
          return this.querySelector('template.mobile');
        }
      }

      get videoElement() {
        return this.querySelector('.yg-featured-banner-video');
      }

      connectedCallback() {
        this.playVideoButton && this.playVideoButton.addEventListener('click', this.playVideoOnClick);
      }

      playVideoOnClick() {
        if (!this.videoTemplate) return;

        // 获取 template 内部的 video 元素
        const videoInTemplate = this.videoTemplate.content.querySelector('video');
        if (!videoInTemplate) return;

        // 克隆 video 元素以便插入（避免多次插入同一个 video 节点）
        const videoClone = this.videoElement || videoInTemplate.cloneNode(true);
        // 替换 template 元素为真实 video
        if (this.videoElement) {
          this.videoElement.style.display = 'block';
        } else {
          this.appendChild(videoClone);
        }
        videoClone.play();
        videoClone.addEventListener('ended', () => {
          videoClone.style.display = 'none';
        });
      }
    }
    customElements.define('yg-featured-banner', YGFeaturedBanner);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-product-list"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    class YGProductList extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.initSwiper();
        // this.formPopup();
      }

      initSwiper() {
        const swiper = new Swiper(this, {
          breakpoints: {
            1600: {
              slidesPerView: 4,
              spaceBetween: 24,
            },
            1150: {
              slidesPerView: 3.1,
              spaceBetween: 20,
            },
            750: {
              slidesPerView: 2.2,
              spaceBetween: 16,
            },
            560: {
              slidesPerView: 1.5,
              spaceBetween: 12,
            },
            280: {
              slidesPerView: 1.1,
              spaceBetween: 12,
            },
          },
          navigation: {
            nextEl: this.querySelector('.swiper-button-next'),
            prevEl: this.querySelector('.swiper-button-prev'),
          },
        });
      }

      formPopup() {
        const popup = document.querySelector('.yg-form-popup-template');
        if (!popup) return;

        const contactButtons = this.querySelectorAll('.yg-product-video-card-contact-button');
        const closeButton = popup.querySelector('.yg-form-popup-close');
        const popupContent =
          popup.querySelector('.yg-form-popup-content') || popup.querySelector('.yg-form-popup-inner');

        let isOpen = false;
        let scrollY = 0;

        // 打开弹窗
        const openPopup = () => {
          if (isOpen) return;

          isOpen = true;
          popup.style.display = 'flex';
          popup.classList.add('active');

          // 锁定 body 滚动
          scrollY = window.scrollY;
          document.body.style.position = 'fixed';
          document.body.style.top = `-${scrollY}px`;
          document.body.style.width = '100%';
          document.body.style.overflow = 'hidden';
        };

        // 关闭弹窗
        const closePopup = () => {
          if (!isOpen) return;

          isOpen = false;
          popup.style.display = 'none';
          popup.classList.remove('active');

          // 重置表单内容
          const forms = popup.querySelectorAll('form');
          forms.forEach((form) => {
            if (typeof form.reset === 'function') {
              form.reset();
            }
          });

          // 解锁 body 滚动
          document.body.style.position = '';
          document.body.style.top = '';
          document.body.style.width = '';
          document.body.style.overflow = '';

          // 恢复滚动位置
          if (scrollY !== undefined) {
            window.scrollTo(0, scrollY);
          }
        };

        // 绑定 contact button 点击事件
        contactButtons.forEach((buttonContainer) => {
          const button = buttonContainer.querySelector('button') || buttonContainer;
          button.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            openPopup();
          });
        });

        // 绑定关闭按钮点击事件
        if (closeButton) {
          closeButton.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            closePopup();
          });
        }

        // 点击背景关闭弹窗
        popup.addEventListener('click', (e) => {
          if (e.target === popup) {
            closePopup();
          }
        });

        // 阻止内容区域的点击事件冒泡
        if (popupContent) {
          popupContent.addEventListener('click', (e) => {
            e.stopPropagation();
          });
        } else {
          // 如果没有找到 popupContent，尝试阻止所有子元素的点击冒泡
          const contentElements = popup.querySelectorAll('.yg-form-popup-inner, .yg-form-popup-content');
          contentElements.forEach((el) => {
            el.addEventListener('click', (e) => {
              e.stopPropagation();
            });
          });
        }

        // ESC 键关闭弹窗
        const handleKeyDown = (e) => {
          if (e.key === 'Escape' && isOpen) {
            closePopup();
          }
        };
        document.addEventListener('keydown', handleKeyDown);

        // 保存清理函数引用
        this._formPopupCleanup = () => {
          document.removeEventListener('keydown', handleKeyDown);
        };
      }

      disconnectedCallback() {
        // 清理弹窗相关的事件监听器
        if (this._formPopupCleanup) {
          this._formPopupCleanup();
        }
      }
    }
    customElements.define('yg-product-list', YGProductList);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-product-parameter-list"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    class YGProductParameterList extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.initSwiper();
      }

      initSwiper() {
        new Swiper(this, {
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
          },
          breakpoints: {
            1150: {
              slidesPerView: 1.6,
              spaceBetween: 24,
            },
            850: {
              slidesPerView: 1.2,
              spaceBetween: 16,
            },
            550: {
              slidesPerView: 1.1,
              spaceBetween: 16,
            },
            260: {
              slidesPerView: 1,
              spaceBetween: 12,
            },
          },
          autoplay: {
            delay: 5000,
            disableOnInteraction: false,
          },
          loop: true
        });
      }
    }
    customElements.define('yg-product-parameter-list', YGProductParameterList);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-tab-video"] && !Shopify.designMode) return;
  try {
    
  class YGTabVideo extends HTMLElement {
    constructor() {
      super();

      this.handleClick = this.handleClick.bind(this);
      this.resizeVideos = this.resizeVideos.bind(this);
    }

    get tabs() {
      return this.querySelectorAll('.yg-tab-video-title');
    }
    get items() {
      return this.querySelectorAll('.yg-tab-video-item');
    }

    connectedCallback() {
      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', (e) => this.handleClick(e, index));
      });

      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(this.resizeVideos);
        this.resizeObserver.observe(this);
      }
      window.addEventListener('resize', this.resizeVideos);
      window.visualViewport?.addEventListener('resize', this.resizeVideos);
      this.resizeVideos();
    }

    disconnectedCallback() {
      this.resizeObserver?.disconnect();
      window.removeEventListener('resize', this.resizeVideos);
      window.visualViewport?.removeEventListener('resize', this.resizeVideos);
    }

    handleClick(e, index) {
      e.preventDefault();
      this.pauseOtherVideos(index);
      this.tabs.forEach((tab) => tab.classList.remove('active'));
      this.items.forEach((item) => item.classList.remove('active'));
      this.tabs[index].classList.add('active');
      this.items[index].classList.add('active');
      this.resizeVideos();
    }

    resizeVideos() {
      const maxHeight = Math.max(0, (window.visualViewport?.height || window.innerHeight) - 250);

      this.items.forEach((item) => {
        const availableWidth = item.clientWidth;
        item.querySelectorAll('.yg-video').forEach((video) => {
          const aspectRatio = this.getAspectRatio(video);
          const height = Math.min(maxHeight, availableWidth / aspectRatio);
          const width = height * aspectRatio;

          video.style.width = `${width}px`;
          video.style.height = `${height}px`;
        });
      });
    }

    getAspectRatio(video) {
      const value = video.style.getPropertyValue('--aspect-ratio').trim();
      const parts = value.split('/').map((part) => Number.parseFloat(part.trim()));

      if (parts.length === 2 && parts.every(Number.isFinite) && parts[1] > 0) {
        return parts[0] / parts[1];
      }

      const ratio = Number.parseFloat(value);
      return Number.isFinite(ratio) && ratio > 0 ? ratio : 16 / 9;
    }

    pauseOtherVideos(activeIndex) {
      this.items.forEach((item, idx) => {
        if (idx === activeIndex) return;
        // 优先暂停 yg-video 自定义组件（内部封装了多种播放器）
        const ygVideo = item.querySelector('yg-video');
        if (ygVideo && typeof ygVideo.pause === 'function') {
          ygVideo.pause();
        } else {
          // 兜底：直接暂停原生 video（若存在）
          const videoEl = item.querySelector('video');
          if (videoEl && typeof videoEl.pause === 'function') {
            videoEl.pause();
          }
        }
      });
    }
  }
  if (!window.customElements.get('yg-tab-video')) {
    window.customElements.define('yg-tab-video', YGTabVideo);
  }

  } catch(e) { console.error(e); }
})();
})();
